import { Injectable } from '@angular/core';
import { Apollo, ApolloBase } from 'apollo-angular';
import gql from 'graphql-tag';
import { GLOBAL_GRAPHQLGATEWAY_NAME, NOTIFICATIONS_NAME } from '../../graphql.module';
import { BadgeCounts } from '../models/badges.model';

@Injectable({ providedIn: 'root' })
export class BadgesService {
    constructor(private apollo: Apollo) {}

    private global_endpoint(): ApolloBase<any> {
        if (window.APP_CONFIG.ignoreGraphQlGateway) return this.apollo.use(NOTIFICATIONS_NAME);

        return this.apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME);
    }

    getBadgeCount(module = null) {
        return this.global_endpoint().query<{ badges: BadgeCounts }>({
            query: GET_BADGES,
            variables: module ? { module } : {},
            fetchPolicy: 'network-only',
            context: {
                displayOverlay: false,
            },
        });
    }
}

export const GET_BADGES = gql`
    query ($module: NoticeModule) {
        badges(module: $module) {
            estimates
            conversations
            rfqs
            applicationIntegrations
            catalogues
            jobs
            integrations
        }
    }
`;
